<template>
  <div>
    <FilesUploader
      :disabled="readonly"
      :show-files="false"
      :name-folder="documentAgreementSource.number"
      :multiple="false"
      dropper
      dropper-variant="blue-label"
      label="Завантажити"
      main-folder="Документы"
      @update:model-value="createFileVersion($event)" />

    <v-card
      v-for="(file, idx) in files.toReversed()"
      :key="idx"
      variant="outlined"
      style="border-color: #e0e4e7"
      class="mt-3">
      <v-card-text>
        <div class="d-flex justify-space-between align-end mb-3">
          <div class="font-weight-bold">
            <span class="font-weight-bold"> Версія {{ file.version }} </span>

            <v-chip
              v-if="file.version === documentAgreementSource.file.version"
              density="compact"
              class="rounded-pill ml-3"
              color="black">
              Поточна
            </v-chip>
          </div>

          <v-btn
            v-if="currentFile.id !== file.id"
            density="compact"
            variant="outlined"
            color="grey"
            @click="viewFile(file)">
            <span class="mr-2">Переглянути</span>
            <v-icon icon="mdi-eye"></v-icon>
          </v-btn>
        </div>

        <div class="text-disabled">{{ file.name }}</div>
        <div class="text-disabled">
          {{ new CustomDate(file.created_at).toString({ time: true }) }} |
          {{ formatFileSize(file.size) }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { useDocumentAgreement } from '../documentAgreement'
import FilesUploader from '@/components/filesUploader/FilesUploader.vue'
import { formatFileSize } from '@/utils/helpers'
import { CustomDate } from 'best-modules/utils'
import { useRouter } from 'vue-router'
import { DocumentAgreementFile } from '@/utils/types/documentAgreement'

export default {
  name: 'Versions',
  components: { FilesUploader },
  methods: { CustomDate },
  setup() {
    const router = useRouter()
    const {
      documentAgreementId,
      documentAgreementSource,
      files,
      readonly,
      currentFile,
      createFileVersion,
    } = useDocumentAgreement()

    const viewFile = (file: DocumentAgreementFile) => {
      currentFile.value = file
      router.push({
        name: 'document-agreement-single-preview',
        params: { id: documentAgreementId.value },
      })
    }

    return {
      files,
      readonly,
      createFileVersion,
      documentAgreementSource,
      formatFileSize,
      currentFile,
      viewFile,
    }
  },
}
</script>

<style scoped lang="scss"></style>
